import React from 'react';
import './StatBlock.less';

function StatBlock({ label, value, unit, tone = 'default' }) {
  return (
    <div className={`gc-stat gc-stat-${tone}`}>
      <div className="gc-stat-label">{label}</div>
      <div className="gc-stat-value">
        <span className="gc-stat-value-num">{value}</span>
        {unit && <span className="gc-stat-value-unit">{unit}</span>}
      </div>
    </div>
  );
}

export default StatBlock;
